import React from 'react';

import { setLastRequestTime } from '../Utils';

const UserReducer = (state, action) => {
  switch (action.type) {
    case 'AUTH_INITIALIZING':
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
      isLoading: action.isLoading,
      apiKey: action.apiKey,
  };
case 'AUTH_CONSENT_STATUS':
  return {
    ...state,
    isLoading: action.isLoading,
    isConsented: action.isConsented,
    groupStatus: action.groupStatus,
    isPrimary: action.isPrimary,
    numberOfClients: action.numberOfClients
};

case 'SCORE_DATA':
  return {
    ...state,
      age: action.age,
      clientType: action.clientType,
      confidenceScoreResult: action.confidenceScoreResult,
      assetAmount: action.assetAmount,
      upperLimit: action.upperLimit,
      lowerLimit: action.lowerLimit,
      showMeter: action.showMeter
};
case 'SSO_DATA':
  return {
    ...state,
    ssoDataError: action.ssoDataError,
    ssoData: action.ssoData
};
case 'SSO_DATA_FAILURE':
  return {
    ...state,
    ssoDataError: action.ssoDataError
};
case 'AUTH_FAILURE':
  return {
    ...state,
    isLoading: action.isLoading,
    isError: {
    httpErrorCode:
      import.meta.env.MODE === 'local'
        ? action.error.response.status
        : action.error,
        msg: action.error.message,
      error: true,
      errorBody: action.error
  }
};
default:
  throw new Error();
}
};

export default function AppContextAPI(definedIndexState) {
  const [cancelled, setCancelled] = React.useState(false);
  console.log('AppContextAPI', definedIndexState);
    const [state, dispatch] = React.useReducer(UserReducer, {
        isAuthenticated: false,
        isConsented: undefined,
        isLoading: false,
        isPrimary: null,
        isError: {
            msg: '',
            error: false,
            httpErrorCode: ''
        },
        ssoData: undefined,
        ssoDataError: false,
        age: undefined,
        clientType: undefined,
        confidenceScoreResult: undefined,
        upperLimit: undefined,
        lowerLimit: undefined,
        assetAmount: null,
        showMeter: false,
        groupStatus: '',
        numberOfClients: undefined,
    });

    const getAuthorization = React.useCallback(async () => {
      setLastRequestTime()

      dispatch({
          type: 'AUTH_INITIALIZING',
          isLoading: false,
          isAuthenticated: true,
      });
    }, []);

    React.useEffect(() => {
        if (!cancelled) {
            console.log('check if user logged in');
            getAuthorization();
        }
        return () => {
            setCancelled(true);
        };
    }, [cancelled, getAuthorization]);

    return [state, dispatch];
}
